import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCircleTwo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25}
    height={25}
    viewBox="0 0 496.158 496.158"
    {...props}
  >
    <path
      d="M248.082.003C111.07.003 0 111.061 0 248.085c0 137 111.07 248.07 248.082 248.07 137.006 0 248.076-111.07 248.076-248.07C496.158 111.061 385.088.003 248.082.003"
      style={{
        fill: "#18a09f",
      }}
    />
    <path
      d="M319.783 325.595q-6.006-4.687-17.432-4.688h-76.465q3.661-5.566 7.178-9.521 8.201-9.96 30.249-27.979 22.044-18.017 31.421-26.44 9.374-8.421 18.384-23.291 9.009-14.867 9.009-33.032-.001-11.57-4.321-22.339-4.323-10.766-12.085-18.97a57.6 57.6 0 0 0-18.018-12.891q-15.82-7.031-38.232-7.031-18.604 0-32.446 5.493c-13.842 5.493-16.846 8.473-22.852 14.429q-9.01 8.936-13.55 19.922-4.542 10.986-4.541 21.094 0 8.35 4.834 13.184c4.834 4.834 7.274 4.834 12.158 4.834q8.349 0 12.671-5.273 4.32-5.273 7.764-15.088 3.44-9.814 4.907-12.012 10.985-16.845 30.176-16.846 9.082.001 16.772 4.102 7.69 4.103 12.158 11.499 4.468 7.4 4.468 16.772 0 8.644-4.175 17.651c-4.175 9.007-6.837 11.865-12.158 17.578q-7.986 8.57-19.995 17.065-6.74 4.543-22.412 18.97-15.676 14.43-35.156 34.644-4.688 4.982-8.643 13.696-3.955 8.717-3.955 13.989 0 8.205 6.152 14.282 6.152 6.08 17.139 6.079H306.6q9.667 0 14.429-4.98 4.76-4.979 4.761-12.158-.002-8.053-6.007-12.744"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
);
export default SvgIconCircleTwo;
